<app-header [trackingResponse]="parcelInformations" *ngIf="parcelInformations"></app-header>

<div class="main_page" *ngIf="parcelInformations">
    <div class="loader_spinner" *ngIf="spinnerService.isLoading | async">
        <mat-progress-spinner mode="indeterminate" diameter="100" style="left: 50%;"></mat-progress-spinner>
    </div>
    <div class="content_container">

        <div class="parcel_informations_container">
            <div *ngIf="alerts.length>0">
                <app-alert [list]="alerts"></app-alert>
            </div>
            <div>
                <app-timeline [trackingResponse]="parcelInformations" [signingCode]="signingCode" [lastEvent]="lastEventActive" [tag]="tag"></app-timeline>
            </div>
            <div *ngIf="parcelInformations.parcel.service.deliveryChoice && isMobile()">
              <app-cta-button [titleBloc]="getDeliveryTitle()" [button]="getDeliveryButtonTitle()"
                  [parcelInformations]="parcelInformations" [shortCode1]="shortCode1" [shortCode2]="shortCode2"
                  popinType="home" [tag]="tag"></app-cta-button>
            </div>
            <div *ngIf="lastEventActive.stepId != 5 && isMobile()">
                <app-delivery-bloc [trackingParcel]="parcelInformations.parcel" [tag]="tag"></app-delivery-bloc>
            </div>
            <div *ngIf="detailParcelSteps.length > 0">
                <app-info-step class="details" [list]="detailParcelSteps" titleBloc="details.details"
                    imgPath="assets/App_Icon_Detais_etapes.svg" color="#EE7203" [tag]="tag"></app-info-step>
            </div>
            <div *ngIf="otherReferences.length > 0">
                <app-other-ref class="info" [list]="otherReferences" titleBloc="details.info"
                    imgPath="assets/Icon-info-White.svg" color="#EE7203" [tag]="tag"></app-other-ref>
            </div>
        </div>
        <div class="actions_container">
            <div *ngIf="lastEventActive.stepId != 5 && !isMobile()">
                <app-delivery-bloc [trackingParcel]="parcelInformations.parcel" [tag]="tag"></app-delivery-bloc>
            </div>
            <div *ngIf="parcelInformations.parcel.service.deliveryChoice && !isMobile()">
                <app-cta-button [titleBloc]="getDeliveryTitle()" [button]="getDeliveryButtonTitle()"
                    [parcelInformations]="parcelInformations" [shortCode1]="shortCode1" [shortCode2]="shortCode2"
                    popinType="home" [tag]="tag"></app-cta-button>
            </div>
            <div *ngIf="isClaimAuthorizedAF && claimReference == null">
                <app-cta-button titleBloc="claim.bloc.title_AF" button="claim.bloc.button"
                    [parcelInformations]="parcelInformations" popinType="claim" [changeRefNumber]="changeRefNumber"
                    [tag]="tag" reasonCode="AF"></app-cta-button>
            </div>
            <div *ngIf="isClaimAuthorizedCL && claimReference == null">
                <app-cta-button titleBloc="claim.bloc.title_CL" button="claim.bloc.button"
                    [parcelInformations]="parcelInformations" popinType="claim" [changeRefNumber]="changeRefNumber"
                    [tag]="tag" reasonCode="CL"></app-cta-button>
            </div>
            <div *ngIf="isClaimAuthorizedAF && claimReference != null">
                <app-claim-reference-bloc *ngIf="claimReference.length > 0" claimInformation='claim.bloc.claim_exist_AF' [claimReference]=claimReference>
                </app-claim-reference-bloc>
            </div>
            <div *ngIf="isClaimAuthorizedCL && claimReference != null">
                <app-claim-reference-bloc *ngIf="claimReference.length > 0" claimInformation='claim.bloc.claim_exist_CL' [claimReference]=claimReference>
                </app-claim-reference-bloc>
            </div>
            <div>
                <app-bloc-eco-responsable></app-bloc-eco-responsable>
            </div>
            <div *ngIf="!isMobile() && parcelInformations.parcel.customerCoBrandingBannerDesktop">
                <app-co-branding [parcelInformations]="parcelInformations" [tag]="tag"></app-co-branding>
            </div>
            <div>
                <app-bloc-help [tag]="tag"></app-bloc-help>
            </div>
        </div>
    </div>

</div>
<app-bloc-commercial [parcelInformations]="parcelInformations" [tag]="tag" *ngIf="isMobile() && parcelInformations.parcel.customerCoBrandingBannerMobile"></app-bloc-commercial>
<app-footer class="footer" [tag]="tag"></app-footer>

